<div class="bary-file-upload-visual">
  <div class="row">
    <div class="col div-image-upload">
      <div class="image-upload-logo" [class.circle]="displayCircle" [style]="_style" [class.image-background]="previewSrc || control.value">
        <div (click)="uploadFileVisual.click()">
          <jhi-bary-icon *ngIf="!previewSrc && !control.value" [icon]="icon" [faDirective]="FAS" size="4x" class="color-gray"></jhi-bary-icon>
        </div>
        <jhi-bary-button
          *ngIf="previewSrc || control.value"
          [tooltip]="'BTN.DELETE' | translate"
          icon="times"
          class="button-delete"
          [rounded]="true"
          [floating]="true"
          size="sm"
          color="danger"
          (clickEvent)="deletePicture()"
        ></jhi-bary-button>
      </div>
    </div>
  </div>
  <input hidden #uploadFileVisual [id]="id" type="file" name="uploadedFile" ng2FileSelect [uploader]="uploader" (onFileSelected)="checkFile($event)" />
  <div *ngIf="_errors.length > 0" class="alert alert-danger" role="alert">
    {{ _errors[0] }}
  </div>
</div>
